var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "finance-deposit-cell",
      class: {
        "finance-deposit-cell-red":
          _vm.cellValue <= 0 || _vm.cellValue > _vm.depositAmountMax,
        "finance-deposit-cell-yellow":
          _vm.cellValue > 0 && _vm.cellValue < _vm.depositAmountMax,
        "finance-deposit-cell-green": _vm.cellValue === _vm.depositAmountMax,
      },
    },
    [_vm._v(" " + _vm._s(_vm.formatAmount(_vm.cellValue)) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }